import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '@shared/models/response.model';
import { SettingsModel } from '@shared/models/settings.model';
import { getCurrentContextIds } from '@shared/utils/current-context.util';

@Injectable({
  providedIn: 'root',
})

export class SettingService {
  constructor(private http: HttpClient) {}

  getSettings() {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/settings`
    );
  }

  getSettingstoSpecificBranch(restaurantId:string, branchId:string) {
    return this.http.get<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/settings`
    );
  }

  editSettings(data: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/settings?_method=PUT`,
      data
    );
  }

  editSettingstoSpecificBranch(restaurantId:string, branchId:string, data: object) {
    return this.http.post<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/settings?_method=PUT`,
      data
    );
  }

  addSettings(data: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/add-settings`,
      data
    );
  }
  
  addSettingstoSpecificBranch(restaurantId:string, branchId:string, data: object) {
    return this.http.post<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/add-settings`,
      data
    );
  }

  deleteFeeSettingFromSpecificBranch(restaurantId: string, branchId: string, index: number) {
    return this.http.delete<ResponseModel<SettingsModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/settings/fees/${index}`
    );
  }
}
